<template>
  <div class="login-page">
    <div class="container-lg">
      <div class="row">
        <div class="col-md-6">
          <Contents />
        </div>
        <!-- use bg-light if there are slides -->
        <div class="col-md-6 border rounded">
            <!-- <Slides /> -->
            <Slide />
        </div>
      </div>
    </div>
    <div>
    
    </div>
  </div>
</template>
<script>
import Contents from '@/components/Contents.vue'
// import Slides from '@/components/Slides.vue'
import Slide from '@/components/SingleSlide.vue'


export default {
  name: 'Home',
  components: {
    Contents,
    // Slides,
    Slide
  }
}
</script>
<style type="text/css">
html, body{
    font-family: DM Sans, Avenir, Arial;
}

.login-page {
    min-height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-page .btn-primary{
    color: #FFFFFF;
    background-color: #678F35;
    border-color: #678F35;
    cursor: pointer;
}

.login-page .btn-primary:hover, 
.login-page .btn-primary:active, 
.login-page .btn-primary:focus{
    color: #FFFFFF;
    background-color: #52722a !important;
    border-color: #52722a !important;
}

.login-page .btn-primary:disabled,
.login-page .btn-primary[disabled]{
    border-color: #85A55D !important;
    background-color: #85A55D;
}

.cursor-pointer{
    cursor: pointer;
}

.login-page a{
    color: #190D30;
    font-weight: 500;
    cursor: pointer;
}

.login-page a:hover{
    color: #000;
    font-weight: 500;
    text-decoration: none;
}
</style>

